import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../../images/edit.svg";
import Delete from "../../../images/delete.svg";
import Logo from "../../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack, Switch } from "@mui/material";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Email } from "@mui/icons-material";
import './Poll.css'

// Import Lucide React icons
import {
  BarChart3,
  Plus,
  X,
  Calendar,
  User,
  CheckCircle,
  Pencil,
  Vote,
  Settings,
  TrendingUp,
  MoreVertical,
  RefreshCw,
  Hash,
  MessageSquare,
  Users,
  Eye,
  EyeOff,
  AlertCircle,
  List,
  Filter,
} from "lucide-react";

export function PollAdmin({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.getPollsAdmin(payload);
      console.log(postData);
      if (postData?.success) {
        setData(postData.polls);
        setnoOfPost(postData.count);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const togglePoll = async (e, pollId) => {
    try {
      setLoader(true);
      const isConfirmed = window.confirm(
        `Are you sure you want to ${
          e.target.checked ? "activate" : "deactivate"
        } this poll?`
      );
      let payload = {
        pollId,
        active: e.target.checked,
      };
      if (isConfirmed) {
        const userData = await api.pollToggle(payload);
        console.log(userData);
        if (userData?.success) {
          console.log("updated");
          getPosts();
        }
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page, resetPage]);

  const handleSearch = async () => {
    if (searchQuery.trim()) {
      try {
        let payload = {
          query: searchQuery.trim(),
        };
        const res = await api.searchPolls(payload);
        if (res?.success) {
          setData(res?.polls || []);
          setnoOfPost(res?.polls?.length || 0);
        } else {
          alert("No polls found with that query");
        }
      } catch (error) {
        console.error("Search error:", error);
        alert("Search failed");
      }
    } else {
      // If search is empty, reset to show all polls
      handleReset();
    }
  };

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
    setSearchQuery("");
  };

  return (
    <>

      {/* Begin Page Content */}
      <div className="container-fluid polls-admin-container">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="polls-header">
              <div className="polls-title-section">
                <div className="polls-title-icon">
                  <BarChart3 size={28} />
                </div>
                <div className="polls-title-text">
                  <h1>Poll Management</h1>
                  <span className="polls-title-badges">{noOfPost} Polls</span>
                </div>
              </div>

              <div className="polls-actions">
                <div className="polls-search-container">
                  <div className="polls-search-input">
                    <input
                      onChange={(e) => setSearchQuery(e.target.value)}
                      value={searchQuery}
                      type="text"
                      placeholder="Search polls by title or creator..."
                      onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                    />
                  </div>
                  <button
                    className="polls-search-button"
                    onClick={handleSearch}
                  >
                    <Search size={18} />
                  </button>
                </div>

                <button className="polls-reset-button" onClick={handleReset}>
                  <RefreshCw size={18} />
                  Reset
                </button>

                <button className="polls-create-button" onClick={handleShow}>
                  <Plus size={18} />
                  Create Poll
                </button>
              </div>
            </div>

            {/* Table Component */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              togglePoll={togglePoll}
            />
          </div>
        </div>
      </div>

      {/* Enhanced Modal */}
      <Modal show={show} onHide={handleClose} centered className="polls-modal">
        <Modal.Body className="p-0">
          <div className="polls-modal-content">
            <div className="polls-modal-header">
              <div className="polls-modal-title">
                <BarChart3 size={24} />
                <h3>Create New Poll</h3>
              </div>
              <button className="polls-modal-close" onClick={handleClose}>
                <X size={20} />
              </button>
            </div>
            <AddPoll getPosts={getPosts} setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>

      {loader && <Loader />}
    </>
  );
}

// Add Search icon component
const Search = ({ size = 18, color = "#9ca3af" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const Table = ({ data, page, setPage, noOfPost, limit, togglePoll }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <style jsx>{`
        
      `}</style>

      <div className="polls-table-container">
        <div className="polls-table-header">
          <h3 className="polls-table-title">
            <List size={20} />
            Poll List
          </h3>
        </div>

        <div className="table-responsive">
          <table className="polls-table">
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-1">
                    <MessageSquare size={16} />
                    Title
                  </div>
                </th>
                <th>
                  <div className="d-flex align-items-center gap-1">
                    <Hash size={16} />
                    Options
                  </div>
                </th>
                <th>
                  <div className="d-flex align-items-center gap-1">
                    <TrendingUp size={16} />
                    Total Votes
                  </div>
                </th>
                <th>
                  <div className="d-flex align-items-center gap-1">
                    <Settings size={16} />
                    Status
                  </div>
                </th>
                <th>
                  <div className="d-flex align-items-center gap-1">
                    <User size={16} />
                    Created By
                  </div>
                </th>
                <th>
                  <div className="d-flex align-items-center gap-1">
                    <Calendar size={16} />
                    Created At
                  </div>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="poll-title-cell" title={item?.title}>
                        {item?.title || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="poll-options-cell">
                        {item?.options?.map((val, key1) => (
                          <div key={key1} className="poll-option-item">
                            <span className="poll-option-votes">
                              {val?.votes || 0}
                            </span>
                            <span className="poll-option-text">
                              {val?.text || "-"}
                            </span>
                          </div>
                        ))}
                      </div>
                    </td>
                    <td>
                      <div className="poll-votes-cell">
                        {item?.totalVotes || 0}
                      </div>
                    </td>
                    <td>
                      <div className="poll-status-cell">
                        <div
                          className={`poll-status-badge ${
                            item?.active
                              ? "poll-status-active"
                              : "poll-status-inactive"
                          }`}
                        >
                          {item?.active ? (
                            <>
                              <Eye size={14} />
                              Active
                            </>
                          ) : (
                            <>
                              <EyeOff size={14} />
                              Inactive
                            </>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="poll-creator-cell">
                        <User size={16} color="#9ca3af" />
                        <span title={item?.createdBy?.email}>
                          {item?.createdBy?.email || "-"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="poll-date-cell">
                        <Calendar size={16} color="#9ca3af" />
                        <span>{formatDate(item?.createdAt)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <Switch
                          checked={item?.active || false}
                          onChange={(e) => togglePoll(e, item?._id)}
                          className="poll-switch"
                          color="primary"
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">
                    <div className="polls-empty-state">
                      <div className="polls-empty-icon">
                        <BarChart3 size={64} />
                      </div>
                      <h4 className="polls-empty-title">No Polls Found</h4>
                      <p className="polls-empty-description">
                        Create your first poll to start collecting votes and
                        feedback from users.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {data.length > 0 && (
          <div className="polls-pagination">
            <div className="d-flex justify-content-center align-items-center">
              <span className="text-sm text-gray-600 mr-4">
                Page {page} of {Math.max(1, Math.ceil(noOfPost / limit))}
              </span>
              <Stack spacing={2}>
                <Pagination
                  count={Math.max(1, Math.ceil(noOfPost / limit))}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                  shape="rounded"
                  size="medium"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export function AddPoll({ getPosts, setShow, onCreated }) {
  const [title, setTitle] = useState("");
  const [options, setOptions] = useState(["", ""]); // start with 2 options
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleOptionChange = (idx, value) => {
    const newOpts = [...options];
    newOpts[idx] = value;
    setOptions(newOpts);
  };

  const addOption = () => setOptions((o) => [...o, ""]);
  const removeOption = (idx) => {
    if (options.length <= 2) return; // keep minimum 2 options
    setOptions((o) => o.filter((_, i) => i !== idx));
  };

  const validate = () => {
    if (!title.trim()) return "Title is required";
    const trimmedOpts = options.map((o) => o.trim()).filter(Boolean);
    if (trimmedOpts.length < 2) return "At least two options are required";
    const lower = trimmedOpts.map((s) => s.toLowerCase());
    if (new Set(lower).size !== lower.length) return "Options must be unique";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const vErr = validate();
    if (vErr) {
      alert(vErr);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        title: title.trim(),
        options: options.map((o) => o.trim()).filter(Boolean),
        active,
      };

      const res = await api.createPoll(payload);

      if (res?.success) {
        setTitle("");
        setOptions(["", ""]);
        setActive(true);
        getPosts();
        setShow(false);
        alert("Poll created successfully!");
      } else {
        alert(res.data?.message || "Failed to create poll");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to create poll");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <div className="polls-modal-body">
        <form onSubmit={handleSubmit}>
          <div className="polls-form-group">
            <label className="polls-form-label">
              <MessageSquare size={18} />
              Poll Title
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="What do you think about our latest product?"
              className="polls-form-input"
              required
            />
            <div className="polls-form-note">
              Enter a clear and engaging question for your poll
            </div>
          </div>

          <div className="polls-form-group">
            <label className="polls-form-label">
              <Hash size={18} />
              Options ({options.filter((o) => o.trim()).length}/min 2)
            </label>

            <div className="polls-options-list">
              {options.map((opt, idx) => (
                <div key={idx} className="polls-option-item">
                  <div
                    style={{
                      background: "#4facfe",
                      color: "white",
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "600",
                      fontSize: "0.875rem",
                    }}
                  >
                    {idx + 1}
                  </div>
                  <input
                    type="text"
                    value={opt}
                    onChange={(e) => handleOptionChange(idx, e.target.value)}
                    placeholder={`Option ${idx + 1}`}
                    className="polls-option-input"
                  />
                  <button
                    type="button"
                    onClick={() => removeOption(idx)}
                    className="polls-option-remove"
                    disabled={options.length <= 2}
                    title={
                      options.length <= 2
                        ? "Minimum 2 options required"
                        : "Remove option"
                    }
                  >
                    <X size={18} />
                  </button>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={addOption}
              className="polls-add-option-btn"
            >
              <Plus size={18} />
              Add Option
            </button>
            <div className="polls-form-note">
              Add at least 2 unique options. Users will vote for their preferred
              choice.
            </div>
          </div>

          <div className="polls-status-toggle">
            <label>
              <input
                type="checkbox"
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
                style={{ transform: "scale(1.2)" }}
              />
              <span>Make poll active immediately</span>
            </label>
            <div
              className={`polls-status-badge ${
                active ? "polls-status-active" : "polls-status-inactive"
              }`}
            >
              {active ? "Active" : "Inactive"}
            </div>
          </div>

          <div className="polls-form-actions">
            <button
              type="button"
              className="polls-form-cancel"
              onClick={() => setShow(false)}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="polls-form-submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm text-light"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Creating...
                </>
              ) : (
                <>
                  <CheckCircle size={18} />
                  Create Poll
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
